import React from 'react';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const filters = [
  { id: 'all', label: 'All Components', icon: FiIcons.FiGrid },
  { id: 'posture', label: 'Posture & Ergonomics', icon: FiIcons.FiActivity },
  { id: 'cables', label: 'Cable Management', icon: FiIcons.FiLink },
  { id: 'focus', label: 'Focus & Acoustics', icon: FiIcons.FiHeadphones },
  { id: 'charging', label: 'Power & Charging', icon: FiIcons.FiCpu },
];

const ProblemFilters = ({ activeFilter, setActiveFilter }) => {
  return (
    <div className="flex overflow-x-auto pb-4 hide-scrollbar gap-2 mb-8">
      {filters.map((filter) => (
        <button
          key={filter.id}
          onClick={() => setActiveFilter(filter.id)}
          className={`flex items-center gap-2 px-4 py-2 rounded-md border text-sm font-medium whitespace-nowrap transition-all ${
            activeFilter === filter.id
              ? 'bg-indigo-50 border-indigo-200 text-indigo-700 shadow-sm'
              : 'bg-white border-slate-200 text-slate-600 hover:bg-slate-50'
          }`}
        >
          <SafeIcon icon={filter.icon} className={activeFilter === filter.id ? 'text-indigo-600' : 'text-slate-400'} />
          {filter.label}
        </button>
      ))}
    </div>
  );
};

export default ProblemFilters;